export const ADMIN = 'ADMIN';
export const SYS_ADMIN = 'SYSTEM ADMIN';
export const OPERATOR = 'OPERATOR';
export const SUPERVISOR = 'SUPERVISOR';
export const FOCUSED_OPERATOR = 'FOCUSED OPERATOR';
export const VIEW_ONLY_OPERATOR = 'VIEW ONLY OPERATOR';

export const QUEUES_ALLOWED_ROLES = [ADMIN, SYS_ADMIN, SUPERVISOR];
